'use strict';

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var nativeAbortController = require('native-abort-controller');

var SubscriptionTracker = /*#__PURE__*/function () {
  function SubscriptionTracker() {
    _classCallCheck(this, SubscriptionTracker);

    this._subs = new Map();
  }

  _createClass(SubscriptionTracker, [{
    key: "subscribe",
    value: function subscribe(topic, handler, signal) {
      var _this = this;

      var topicSubs = this._subs.get(topic) || [];

      if (topicSubs.find(function (s) {
        return s.handler === handler;
      })) {
        throw new Error("Already subscribed to ".concat(topic, " with this handler"));
      }

      var controller = new nativeAbortController.AbortController();

      this._subs.set(topic, [{
        handler: handler,
        controller: controller
      }].concat(topicSubs));

      if (signal) {
        signal.addEventListener('abort', function () {
          return _this.unsubscribe(topic, handler);
        });
      }

      return controller.signal;
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(topic, handler) {
      var subs = this._subs.get(topic) || [];
      var unsubs;

      if (handler) {
        this._subs.set(topic, subs.filter(function (s) {
          return s.handler !== handler;
        }));

        unsubs = subs.filter(function (s) {
          return s.handler === handler;
        });
      } else {
        this._subs.set(topic, []);

        unsubs = subs;
      }

      if (!(this._subs.get(topic) || []).length) {
        this._subs.delete(topic);
      }

      unsubs.forEach(function (s) {
        return s.controller.abort();
      });
    }
  }]);

  return SubscriptionTracker;
}();

exports.SubscriptionTracker = SubscriptionTracker;